import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Layout, Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SEOMetadata, { seoConfigs } from '../../components/SEOMetadata';
import CounterMain from './components/CounterMain';

const { Header, Content } = Layout;
const { Title } = Typography;

const RandomCounterApp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getUserEmail } = useAuth();

  const handleBackToApps = () => {
    navigate('/');
  };

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #FFF8F0 0%, #FFE4B5 100%)' }}>
      <SEOMetadata {...seoConfigs.randomCounter} />
      
      <Header style={{ 
        background: 'linear-gradient(135deg, #FF8C00 0%, #FF7F00 100%)',
        padding: '0 16px',
        boxShadow: '0 2px 8px rgba(255, 140, 0, 0.15)'
      }}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between',
          height: '100%'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <Button
              type="text"
              icon={<ArrowLeftOutlined />}
              onClick={handleBackToApps}
              style={{ 
                color: 'white',
                fontSize: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              Back to Apps
            </Button>
            <Title level={3} style={{ 
              color: 'white', 
              margin: 0,
              fontSize: 'clamp(18px, 4vw, 24px)'
            }}>
              🔢 Random Counter
            </Title>
          </div>
          {getUserEmail() && (
            <span style={{ 
              color: 'rgba(255, 255, 255, 0.8)', 
              fontSize: '14px' 
            }}>
              {getUserEmail()}
            </span>
          )}
        </div>
      </Header>

      <Content style={{ 
        padding: '12px',
        background: 'transparent'
      }}>
        <Routes>
          <Route path="/" element={<CounterMain />} />
          <Route path="/*" element={<Navigate to="/apps/random-counter" replace />} />
        </Routes>
      </Content>
    </Layout>
  );
};

export default RandomCounterApp; 